import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import TheArtOfFirstImpressions from "./sections/TheArtOfFirstImpressions";
import TheAiAlchemy from "./sections/TheAiAlchemy";
import VisualTransformationGallery from "./sections/VisualTransformationGallery";
import TheRoiOfElegance from "./sections/TheRoiOfElegance";
import YourInvestment from "./sections/YourInvestment";
import VoicesOfExcellence from "./sections/VoicesOfExcellence";
import ElevateYourProperty from "./sections/ElevateYourProperty";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <TheArtOfFirstImpressions />
      <TheAiAlchemy />
      <VisualTransformationGallery />
      <TheRoiOfElegance />
      <YourInvestment />
      <VoicesOfExcellence />
      <ElevateYourProperty />
      <Footer />
    </div>;
}